export default {
  state: {
    progress: false,
    confirm_modal: false,
    confirm_file: false,
    assign_lead_modal: false,
    report_lead_modal: false,
    view_details_modal: false,
    forgot_password_modal: false,
  },
  mutations: {
    toggle(state, toggleType) {
      state[toggleType] = !state[toggleType];
    },
    setToggle(state, data) {
      state[data.type] = data.bool;
    },
  },
  actions: {
    toggle({ commit }, toggleType) {
      commit('toggle', toggleType);
    },
    setToggle({ commit }, data) {
      commit('setToggle', data);
    },
  },
};
